import { useEffect } from "react";

export const TujhachMiTharlo = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div className="modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", zIndex: 1050, }}>
                <div className="modal-content" style={{ padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", overflowY: "auto", }}>
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemsmar/tujhach-me-tharlo.jpg" alt=" तुझाच मी ठरलो | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>तुझाच मी ठरलो</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        लपविण्यास दुःख आता<br />
                        घेत असतो शब्दांचा सहारा,<br />
                        सांत्वनांनी लोकांच्या<br />
                        ठरतोय मी बेचारा.<br />
                        <br />
                        गरिबीची कधी ना वाटली<br />
                        कधी एवढी लाज,<br />
                        ऐकुनी सांत्वने<br />
                        वाटते जेवढी आज.<br />
                        <br />
                        दुःखद आठवणींनी तुझ्या<br />
                        होतो मी हतबल,<br />
                        पण लोकांच्या नजरेंनी<br />
                        ठरतोय आता दुर्बल.<br />
                        <br />
                        हारलो प्रेमात<br />
                        मी माझा सन्मान,<br />
                        दुनियादारी वावरताना<br />
                        ना उंचावते मान.<br />
                        <br />
                        पण नाश प्रेमची तुझ्या<br />
                        चडलीय मला फार,<br />
                        मग वाटते करावे प्रेम<br />
                        तुझ्यावरच अपरंपार.<br />
                        <br />
                        रांझा, मजनू, रोमियो,<br />
                        यांनाही ना भेटले प्रेयसीचे सौभाग्य,<br />
                        तरीही त्यांनी केले<br />
                        लाखो मनांवर राज्य.<br />
                        <br />
                        त्याचप्रमाणे जरी सर्वांसमोर<br />
                        ठरलीय मी शून्य,<br />
                        तरी आठवणींनी तुझ्या<br />
                        झालोय मी धन्य.<br />
                        <br />
                        असेल जीव<br />
                        जीवात या जोपर्यंत,<br />
                        करेन प्रेम<br />
                        तुझ्यावरच तोपर्यंत.<br />
                        <br />
                        प्रेमात तुझ्या मी<br />
                        जरी हरलो सर्वकाही,<br />
                        पण जगासाठी या साऱ्या<br />
                        तुझाच मी ठरलो.<br />
                        <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
